import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useApolloClient } from '@apollo/client/react'
import { Button } from '../Button'
import VehicleSearchModal from '../VehicleSearchModal'
import { VehicleInfo } from '../VehicleSearchModal/types'
import { Maybe } from '../../common/types'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { messages } from './messages'

interface SearchVehicleInfoProps {
  searchString?: string | null
  buttonText?: string
  handleResults?: (vehicleInfo: VehicleInfo) => void
  vehicleInfoCheckId: Maybe<number>
  getValue: any
  setValue: (field: string, value: string) => void
}

export const SearchVehicleInfo: React.FunctionComponent<SearchVehicleInfoProps> = ({
  searchString = null,
  buttonText,
  handleResults,
  vehicleInfoCheckId,
  getValue,
  setValue
}) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  const [activeSearch, setActiveSearch] = useState<boolean>(false)
  const [currentSearchString, setCurrentSearchString] = useState<string | null>(searchString)
  const client = useApolloClient()

  return (
    <>
      {activeSearch && searchString && (
        <VehicleSearchModal
          getValue={getValue}
          setValue={setValue}
          vehicleRegistration={searchString}
          client={client}
          close={() => setActiveSearch(false)}
          buttonText={buttonText}
          vehicleInfoCheckId={
            vehicleInfoCheckId && currentSearchString === searchString ? vehicleInfoCheckId : null
          }
          buttonHandler={vehicleInfo => {
            setCurrentSearchString(searchString)
            if (handleResults) handleResults(vehicleInfo)
          }}
        />
      )}
      <Button
        size="s"
        category="search"
        disabled={searchString === ''}
        label={vehicleInfoCheckId && currentSearchString === searchString ? formatMessage(messages.showLabel) : formatMessage(messages.searchLabel)}
        onClick={() => {
          setActiveSearch(true)
        }}
      />
    </>
  )
}
